<template>
    <div class="item-m3">
         <div>{{itemproperties.itemno}}</div>
         <b-form inline>
             <b-form-group id="exampleInputGroup1"
                    label="Piezas:"
                    label-for="inlineFormInputCant">
            <b-form-input autocomplete="off" id="inlineFormInputCant" placeholder="Piezas" v-focus @focus.native="$event.target.select()" v-model="itemproperties.qty"/> 
            </b-form-group>
             <b-form-group id="exampleInputGroup1"
                    label="Largo:"
                    label-for="inlineFormInputLongitud">
            <b-form-input autocomplete="off" id="inlineFormInputLongitud" placeholder="Largo" v-model="itemproperties.length"/>
            </b-form-group>
            <b-form-group id="exampleInputGroup1"
                    label="Ancho:"
                    label-for="inlineFormInputAncho">
            <b-form-input autocomplete="off" id="inlineFormInputAncho" placeholder="Ancho" v-model="itemproperties.width" />
            </b-form-group>
            <b-form-group id="exampleInputGroup1"
                    label="Grueso:"
                    label-for="inlineFormInputAlto">
            <b-form-input autocomplete="off" id="inlineFormInputAlto" placeholder="Grueso" v-model="itemproperties.height"/>
            </b-form-group>
            <b-button @click=AddM3Item() variant="primary">Añadir {{parseFloat(itemproperties.length * itemproperties.height * itemproperties.width * itemproperties.qty).toFixed(5)}}</b-button>
        </b-form>
    </div>   
</template>

<script>
var axios = require('axios')

export default {
    name: 'ItemM3',
    data() {
        return {
            selected: [],    
            options : [],
            inputtimeout: 0
        }
    },
    computed:{
        itemproperties(){
            return this.$store.state.itemproperties
        }
    },     
    methods:{
        AddM3Item(){
                var selected =  {
                    custId: this.$store.state.customer.id,
                    itemno: this.itemproperties.itemno,
                    qty: parseFloat(this.itemproperties.length * this.itemproperties.height * this.itemproperties.width * this.itemproperties.qty).toFixed(5),
                    location : localStorage.getItem('defaultlocation'),
                    unitprice: 0,
                    linedisc: 0,
                    usercardid : this.$store.state.UserCardId.cardNo,
                    PosId: this.$store.state.PosId
                }
                axios.post(this.ApiBaseUrl + 'Sales/GetSalesLinePrice',JSON.stringify(selected),{headers: {"Content-Type": "application/json"}})
                .then((response) => {        
                    var data = JSON.parse(response.data.body.res)                    
                    this.$set(selected,'itemno',this.itemproperties.itemno);
                    this.$set(selected,'description',this.itemproperties.description);
                    this.$set(selected,'unitprice',data.unitprice.replace(/\,/g,''));
                    this.$set(selected,'qty',selected.qty);
                    this.$set(selected,'m3length',this.itemproperties.length);
                    this.$set(selected,'m3height',this.itemproperties.height);
                    this.$set(selected,'m3width',this.itemproperties.width);
                    this.$set(selected,'m3qty',this.itemproperties.qty);
                    this.$set(selected,'linedisc',data.linedisc.replace(/\,/g,''));
                    this.$set(selected,'lineamount',data.lineamount.replace(/\,/g,''));
                    this.$set(selected,'vat',data.vat.replace(/\,/g,''));
                    this.$set(selected,'linetotal',data.linetotal.replace(/\,/g,''));
                    this.$set(selected,'location',localStorage.getItem('defaultlocation'))
                    this.$set(selected,'availqty',data.availqty.replace(/\,/g,''))  
                    this.$set(selected,'dtoManual',0);
                    this.$store.commit('addItem', selected)
                    this.$store.commit('setglobaldiscpct',data.globaldiscpct) 
                    this.$store.commit('clearitemproperties')                                     
                })                   
            }    
        
    },
    directives: {
        focus: {
            // directive definition
            inserted: function (el) {
            el.focus()
            }
        }
    }
}
</script>

<style scoped>

</style>